import { PROMOTION_TYPES } from '@/domainLogic/index.ts';
import type { DealCard } from './dealCardTypes.ts';

// A results card shows the kids-stay-free badge when its rate carries the children-free offer AND the hotel
// is not a Top Secret Hotel (there the badge is suppressed, see EvolutionCard/Gallery). Used to gate the
// results→detail `fromKidsFreeBadge` flag so the CUX 3966 filter only runs when that badge was visible.
export const showsKidsFreeBadge = (dealCard: DealCard | undefined): boolean =>
  dealCard?.product?.rate?.offers?.childrenFree === true &&
  !dealCard?.promotionTypes?.includes(PROMOTION_TYPES.TOP_SECRET_HOTELS);
